import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SmartContractViewService } from "../smart-contract-view.service";
import { FabricChaincode } from "@aptsi-types";
import { Subject } from "rxjs/internal/Subject";
import { KeycloakStateService } from "src/app/core/service/utility.service";

@Component({
  selector: 'app-smart-contract-view-search',
  templateUrl: './smart-contract-view-search.component.html',
  styleUrls: ['./smart-contract-view-search.component.scss']
})
export class SmartContractViewSearchComponent implements OnInit {

  contracts: FabricChaincode[] = [];
  filteredData: FabricChaincode[] = [];
  searchedData: FabricChaincode[] = [];

  issearch: boolean = false;

  // ─── Pagination ───────────────────────────────────────────────
  currentPage = 1;
  itemsPerPage = 7;
  totalPages = 1;

  organizationId: string | null = '';

  // ─── Search ──────────────────────────────────────────────────
  searchText: string = "";
  filterByHeader: string = "all";
  searchTextChanged = new Subject<string>();
  filterByStatus: string = '';

  

  headers = [
   { name: 'ID', property: 'chaincodeId', showInDropdown: true },
    { name: 'Smart Contract Name', property: 'chaincodeName', showInDropdown: true },
    { name: 'Channel', property: 'channelName', showInDropdown: true },
    { name: 'Status', property: 'status', showInDropdown: true }
  ];

  buttonConfig =
    { view: true }
    ;

  constructor(
    private service: SmartContractViewService,
    private router: Router,
    private route: ActivatedRoute,
    private keycloakStateService: KeycloakStateService
  ) { }

  ngOnInit(): void {
     this.organizationId = this.keycloakStateService.getOrganizationId();
    this.fetch();
  }

  fetch(): void {
    this.service.getContracts(this.organizationId).subscribe((res: any[]) => {
      this.contracts = res;
      this.filteredData = this.contracts;
    });
  }

  back(): void {
    this.router.navigate(["secure-blockchain/auth-tools"]);
  }

  changePage(page: number): void {
    this.currentPage = page;
  }

  onSearchTextChange(): void {
    if (!this.searchText) {
      this.issearch = false;
      return;
    }

    this.issearch = true;

    this.service.searchContracts(this.currentPage-1, this.searchText, this.filterByHeader, this.organizationId)
      .subscribe((res: any[]) => {
        this.searchedData = res;
      });
  }

  handleAction(event: any): void {
    const row = event.rowData;

    if (event.action === "View") {
      this.router.navigate(['../', row.chaincodeId], {
        relativeTo: this.route
      });
    }
  }
}